// import inbox from '/assets/icons/note/file/open.svg'
// import inbox from '../../../public/assets/icons/note/file/op'
// import addAccount from '../../../public/assets/icons/email/plus-blue.svg'
// export { default as AcademicCapIcon } from './AcademicCapIcon'


const importedIcons = {
    action: '/assets/icons/imports/action.svg',
    activityLog: '/assets/icons/imports/activityLog.svg',
    addCollection: '/assets/icons/imports/addCollection.svg',
    addCustomField: '/assets/icons/imports/addCustomField.svg',
    advanceSearch: '/assets/icons/imports/advanceSearch.svg',
    archive: '/assets/icons/imports/archive.svg',
    arrowLeft: '/assets/icons/imports/arrowLeft.svg',
    arrowRight: '/assets/icons/imports/arrowRight.svg',
    arrowUp: '/assets/icons/imports/arrowUp.svg',
    automation: '/assets/icons/imports/automation.svg',
    changeStage: '/assets/icons/imports/changeStage.svg',
    check: '/assets/icons/imports/check.svg',
    comunications: '/assets/icons/imports/comunications.svg',
    conditionalFormat: '/assets/icons/imports/conditionalFormat.svg',
    copy: '/assets/icons/imports/copy.svg',
    copyFieldUrl: '/assets/icons/imports/copyFieldUrl.svg',
    costumizeField: '/assets/icons/imports/costumizeField.svg',
    decreasingSort: '/assets/icons/imports/decreasingSort.svg',
    deleteField: '/assets/icons/imports/deleteField.svg',
    document: '/assets/icons/imports/document.svg',
    duplicate: '/assets/icons/imports/duplicate.svg',
    edit: '/assets/icons/imports/edit.svg',
    editFieldPermissions: '/assets/icons/imports/editFieldPermissions.svg',
    exclamation: '/assets/icons/imports/exclamation.svg',
    export: '/assets/icons/imports/export.svg',
    eye: '/assets/icons/imports/eye.svg',
    filterField: '/assets/icons/imports/filterField.svg',
    folder: '/assets/icons/imports/folder.svg',
    folderPlus: '/assets/icons/imports/folder-plus.svg',
    groupBy: '/assets/icons/imports/groupBy.svg',
    groupFiled: '/assets/icons/imports/groupFiled.svg',
    hideField: '/assets/icons/imports/hideField.svg',
    import: '/assets/icons/imports/import.svg',
    inbox: '/assets/icons/imports/inbox.svg',
    increasingSort: '/assets/icons/imports/increasingSort.svg',
    insertRight: '/assets/icons/imports/insertRight.svg',
    insertLeft: '/assets/icons/imports/insertLeft.svg',
    invertSelect: '/assets/icons/imports/invertSelect.svg',
    invitations: '/assets/icons/imports/invitations.svg',
    more: '/assets/icons/imports/more.svg',
    notebook: '/assets/icons/imports/notebook.svg',
    pages: '/assets/icons/imports/pages.svg',
    permisions: '/assets/icons/imports/permisions.svg',
    pin: '/assets/icons/imports/pin.svg',
    planner: '/assets/icons/imports/planner.svg',
    plus: '/assets/icons/imports/plus.svg',
    properties: '/assets/icons/imports/properties.svg',
    record: '/assets/icons/imports/record.svg',
    request: '/assets/icons/imports/request.svg',
    savedFilters: '/assets/icons/imports/savedFilters.svg',
    selectAll: '/assets/icons/imports/selectAll.svg',
    selectNone: '/assets/icons/imports/selectNone.svg',
    send: '/assets/icons/imports/send.svg',
    setting: '/assets/icons/imports/setting.svg',
    share: '/assets/icons/imports/share.svg',
    shortcut: '/assets/icons/imports/shortcut.svg',
    sortBy: '/assets/icons/imports/sortBy.svg',
    sprint: '/assets/icons/imports/sprint.svg',
    stage: '/assets/icons/imports/stage.svg',
    tasking: '/assets/icons/imports/taking.svg',
    trash: '/assets/icons/imports/trash.svg',
    undo: '/assets/icons/imports/undo.svg',
    upload: '/assets/icons/imports/upload.svg',
    userPerspective: '/assets/icons/imports/userPerspective.svg',
    variables: '/assets/icons/imports/variables.svg',
    whiteBoard: '/assets/icons/imports/whiteBoard.svg',
    winrarZip: '/assets/icons/imports/winrar-zip.svg',
    printLable: '/assets/icons/imports/printer.png',
}

export default importedIcons
